<template>
  <div id="decLeftNav">
    <Login v-if="isLogin" @LoginOpen="openL" />
    <div class="navTop" v-if="$uName">
      <img v-if="showImg" :src="userinfo.Image || require('../assets/Declare/10.png')" />
      <img v-else :src="userinfo.HeaderImg || require('../assets/Declare/10.png')" alt />
      <div class="up" @click="uploadImg">
        <img src="../assets/back/9.png" alt />
        上传头像
      </div>
      <div>
        <div class="name">
          <img src="../assets/Declare/tx.png" />
          <p>{{ $uName }}</p>
        </div>
        <p>{{ userinfo.CompanyName }}</p>
      </div>
    </div>
    <div class="navTop" v-else>
      <div class="img">
        <img src="../assets/Declare/10.png" />
      </div>
      <div>
        <span>当前用户未登录</span>
      </div>
    </div>
    <div class="nav" v-if="$uName">
      <div class="nav" v-if="t != 1 && t != 5">
        <div class="btn" @click="GoCenter">前往个人中心</div>
      </div>
      <div v-else-if="t == 5"></div>
      <ul v-else>
        <li v-for="(fatheritem, index) in nav" :key="index">
          <div class="Major" @click="To(index)" :class="{ active: fatheritem.active }">
            <div>
              <img v-show="index != 0 && index != 4" :src="fatheritem.active ? fatheritem.imgs : fatheritem.img" />
              <svg v-show="index == 0 || index == 4" :t="fatheritem.t" class="icon leftimg" viewBox="0 0 1024 1024"
                version="1.1" xmlns="http://www.w3.org/2000/svg" :p-id="fatheritem.p_id">
                <path :d="fatheritem.d" :p-id="fatheritem.p_p_id" :fill="fatheritem.active ? '#fff' : '#2d65d2'" />
                <!-- p-id:+1 -->
              </svg>
              {{ fatheritem.name }}
            </div>
            <img
              :src="fatheritem.item.length > 0 ? (fatheritem.isOpen ? (fatheritem.active ? require('../assets/back/04.png') : require('../assets/back/03.png')) : (fatheritem.active ? require('../assets/back/02.png') : require('../assets/back/01.png'))) : ''" />
          </div>
          <div v-if="fatheritem.isOpen">
            <ul>
              <li v-for="(it, i) in fatheritem.item" :key="i" :class="{ active: it.active }" @click="To(index, i)">
                {{ it.name }}
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <el-upload ref="uploads" id="upload1" style="opacity:0" class="avatar-uploader" :http-request="upload"
        :auto-upload="false" action="upload1" :on-success="handleSuccess" :on-change="submitUpload"
        :show-file-list="false" :before-upload="beforeAvatarUpload" accept=".jpg, .jpeg, .png">
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </div>
    <div class="nav" v-else>
      <div class="btn" @click="openLogin">登录</div>
    </div>
  </div>
</template>
<script>
import Login from "../components/Login";

export default {
  name: "decLeftNav",
  data() {
    return {
      isLogin: false,
      userinfo: {},
      ReportID1: "",
      nav: [
        {
          name: "消息中心",
          t: "1592536308994",
          p_id: "18485",
          p_p_id: "18486",
          d:
            "M875.51094947 851.65002004h-322.56441626l-101.92446396 113.26576992c-13.99252034 15.46541722-37.70616007 16.79102442-53.31886697 2.79850408-15.46541722-13.99252034-16.79102442-37.70616007-2.79850407-53.31886699l113.11848022-125.63810368c7.2171947-7.95364315 17.38018317-12.51962347 27.98504068-12.51962348h339.35544068c34.7603663 0 62.89269668-28.13233036 62.89269669-62.89269668V185.45876217c0-34.7603663-28.13233036-62.89269668-62.89269669-62.8926967H146.5742846c-34.7603663 0-62.89269668 28.13233036-62.89269671 62.8926967v527.88624104c0 34.7603663 28.13233036 62.89269668 62.89269671 62.89269668h163.34426375c20.76784598 0 37.70616007 16.9383141 37.70616008 37.7061601 0 20.76784598-16.9383141 37.70616007-37.70616008 37.70616005H146.5742846c-76.29605827 0-138.30501683-61.86166887-138.30501685-138.30501683V185.45876217c0-76.29605827 61.86166887-138.30501683 138.30501685-138.30501684h728.93666487c76.29605827 0 138.30501683 61.86166887 138.30501684 138.30501684v527.88624104c0 76.44334797-62.00895857 138.30501683-138.30501684 138.30501683z m-138.30501683-540.4058645c20.76784598 0 37.70616007 16.9383141 37.70616006 37.70616008 0 20.76784598-16.9383141 37.70616007-37.70616006 37.70616007H284.73201173c-20.76784598 0-37.70616007-16.9383141-37.70616006-37.70616007 0-20.76784598 16.9383141-37.70616007 37.70616006-37.70616008h452.47392091zM510.96897217 512.29457937c20.76784598 0 37.70616007 16.9383141 37.7061601 37.70616009 0 20.76784598-16.9383141 37.70616007-37.7061601 37.70616007H284.73201173c-20.76784598 0-37.70616007-16.9383141-37.70616006-37.70616007 0-20.76784598 16.9383141-37.70616007 37.70616006-37.70616009h226.23696044z m0 0",
          // img: require("../assets/Declare/07.png"),
          // imgs: require("../assets/Declare/08.png"),
          active: false,
          isOpen: false,
          item: [],
          to: "/MessageCenter",
        },
        {
          name: "申报说明",
          img: require("../assets/Declare/01.png"),
          imgs: require("../assets/Declare/02.png"),
          active: false,
          isOpen: false,
          item: [],
          to: "/Declare",
        },
        {
          name: "成果申报",
          img: require("../assets/Declare/03.png"),
          imgs: require("../assets/Declare/04.png"),
          active: false,
          isOpen: false,
          item: [
            { name: "申报表填写", to: "/Surface", active: false },
            { name: "成果主报告", to: "/Report", active: false },
            { name: "成果附件", to: "/Attachment", active: false },
          ],
          to: "",
        },
        {
          name: "申报信息",
          img: require("../assets/Declare/05.png"),
          imgs: require("../assets/Declare/06.png"),
          active: false,
          isOpen: false,
          item: [],
          to: "/tableList",
        },
        {
          name: "个人信息",
          t: "1592536463591",
          p_id: "19808",
          p_p_id: "19809",
          d:
            "M799.216 347.664c0-181.031-146.773-327.805-327.773-327.805-181.03 0-327.804 146.774-327.804 327.805a317.595 317.595 0 0 0 167.502 283.989A441.096 441.096 0 0 0 37.98 959.58a36.74 36.74 0 0 0 29.044 43.567h7.293a35.437 35.437 0 0 0 36.305-29.014 369.943 369.943 0 0 1 356.942-298.728h7.26A330.442 330.442 0 0 0 799.217 347.6v0.063z m-582.749 0a254.945 254.945 0 0 1 509.921 0 257.303 257.303 0 0 1-251.283 254.913H464.12a259.041 259.041 0 0 1-247.622-254.913z m506.29 327.804a34.35 34.35 0 0 0 36.306 36.274H941.15a36.305 36.305 0 1 0 0-72.61H759.001a36.43 36.43 0 0 0-36.274 36.305z m218.516 105.534H649.868a36.43 36.43 0 1 0 0 72.859h291.405a36.43 36.43 0 0 0 0-72.86z m0 145.749H653.498a36.43 36.43 0 0 0 0 72.828h287.744a34.35 34.35 0 0 0 36.306-36.305c0-20.108-16.23-36.43-36.306-36.523h0.031z",
          // img: require("../assets/Declare/gerens.png"),
          // imgs: require("../assets/Declare/geren.png"),
          active: false,
          isOpen: false,
          item: [],
          to: "/Personage",
        },
      ],
      t: 1,
      scroll: "",
      showImg: false,
      childReportID: "",
    };
  },
  inject: ["reload"],
  props: {},
  created() {
    this.setType();
  },
  components: {
    Login,
  },
  watch: {
    childReportID: function (val) {
      // console.log(val, "sdasdlj");
      this.$emit("isReportID", val);
    },
  },
  mounted() {
    this.t = sessionStorage.getItem("t");

    this.userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
    this.getActive();
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    getActive() {
      for (let n = 0; n < this.nav.length; n++) {
        this.nav[n].active = false;
        for (let c = 0; c < this.nav[n].item.length; c++) {
          this.nav[n].item[c].active = false;
        }
      }
      for (let s = 0; s < this.nav.length; s++) {
        if (this.nav[s].to == this.$route.path) {
          this.nav[s].active = true;
        }
        for (let j = 0; j < this.nav[s].item.length; j++) {
          if (this.nav[s].item[j].to == this.$route.path) {
            this.nav[s].item[j].active = true;
            this.nav[s].active = true;
            this.nav[s].isOpen = true;
          }
        }
      }
    },
    To(i, s) {
      // console.log(this.nav);
      // console.log(this.nav[i].item);
      // console.log(sessionStorage.getItem("ReportID"), "Rid");
      // if(this.nav[i].name=="成果申报"){
      //   if(sessionStorage.getItem("isTable")=="false"){
      //     this.$router.replace("/Declare");
      //   }
      // }z

      if (i == 2) {
        let that = this;

        that.$axios
          .post(
            "report/myreport?token=" +
            sessionStorage.getItem("token")
          )
          .then(function (res) {
            console.log(res, 666);
            if (res.data.code == 10000) {
              if (res.data.zt == 0) {
                that.$router.replace("/Declare");
              } else {
                console.log(res.data.zt);
                if (res.data.zt == 1) {
                  sessionStorage.setItem("ReportID", res.data.data.reportID);
                  console.log(this.childReportID);
                } else if (res.data.zt == 2) {
                  console.log(66666666666666);
                  that.nav[2].isOpen = false;
                  that.$alert("报告查重中,请勿操作!", "提示", {
                    confirmButtonText: "确定",
                  });

                  return;
                } else if (res.data.zt == 3) {
                  that.nav[2].isOpen = false;
                  that.$alert("报告生成中,请勿操作!", "提示", {
                    confirmButtonText: "确定",
                  });

                  return;
                }
              }
            } else if (res.data.code == 10002) {
              that.$message({
                type: "warning",
                message: res.data.msg,
              });
            }
            console.log("进入判断");
            that.$refs.LeftNav.isTable();
          })
          .catch(function () { });
      }
      if (this.nav[i].item.length > 0 && s === undefined) {
        this.nav[i].isOpen = !this.nav[i].isOpen;
      } else {
        let e;
        if (s === undefined) {
          e = this.nav[i].to;
        } else {
          if (this.$route.query.ReportID) {
            e =
              this.nav[i].item[s].to +
              "?ReportID=" +
              this.$route.query.ReportID;
          } else {
            e = this.nav[i].item[s].to;
          }
        }
        if (e != this.$route.path && e != "") {
          this.$router.push(e);
          sessionStorage.setItem("isListGo", false);
        }
      }
      console.log(this.scroll, "top");
      sessionStorage.setItem("scroll", this.scroll);
    },
    openLogin() {
      console.log(1);
      this.isLogin = true;
    },
    openL(e) {
      if (e) {
        this.isLogin = false;
      }
    },
    //
    isTable() {
      console.log("触发");
      console.log(!!sessionStorage.getItem("isTable"), 456);
      if (sessionStorage.getItem("isTable") == "false") {
        console.log("截取");
        this.nav[2].item.splice(0, 3);
        console.log(this.nav[2].item, "nav2");
      }
    },
    setType() {
      var userinfo = sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(userinfo);
      var token = sessionStorage.getItem("token");
      if (token.split("-")[0] == "user") {
        if (userinfo.type == 1) {
          sessionStorage.setItem("type", 0);
        } else {
          sessionStorage.setItem("type", 3);
        }
      } else {
        if (userinfo.Rank == 0) {
          sessionStorage.setItem("type", 2);
        } else {
          sessionStorage.setItem("type", 1);
        }
      }
      if (
        sessionStorage.getItem("type") != 1 &&
        sessionStorage.getItem("type") != 2
      ) {
        this.showImg = true;
      }
    },
    GoCenter() {
      var userinfo = sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(userinfo);
      var token = sessionStorage.getItem("token");
      if (token.split("-")[0] == "user") {
        if (userinfo.type == 1) {
          sessionStorage.setItem("type", 0);
          this.$router.replace("/Bgmyproject");
        } else {
          sessionStorage.setItem("type", 3);
          this.$router.replace("/Bgreview");
        }
      } else {
        if (userinfo.Rank == 0) {
          sessionStorage.setItem("type", 2);
          this.$router.replace("/Announcement");
        } else {
          sessionStorage.setItem("type", 1);
          this.$router.replace("/Bgjurisdiction");
        }
      }
    },
    uploadImg() {
      document.querySelector(".avatar-uploader input").click();
    },
    submitUpload() {
      this.$refs.uploads.submit();
    },
    // 测试上传
    handleSuccess(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/gif" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      console.log("pppp");
      if (!isJPG) {
        this.$message.error("上传图片只能是图片格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    upload(file) {
      let that = this;
      console.log(file);
      var formData = new FormData();
      formData.append("file", file.file);
      formData.append("upload_type", "image");
      that.$axios
        .post(
          "upload/index?token=" + sessionStorage.getItem("token"),
          formData,
          {
            headers: {
              "Content-type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 10000) {
            if (this.showImg) {
              this.userinfo.Image = res.data.data;
            } else {
              console.log(res);
              this.userinfo.HeaderImg = res.data.data;
            }

            let url = "user/update";
            var token = sessionStorage.getItem("token");
            if (token.split("-")[0] == "company") {
              url = "company/update";
            }
            that.$axios
              .post(
                url + "?token=" + sessionStorage.getItem("token"),
                that.$qs.stringify(this.userinfo)
              )
              .then((res) => {
                console.log(res);
                if (res.data.code == 10000) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  let arr = JSON.stringify(this.userinfo);
                  sessionStorage.setItem("userinfo", arr);
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "warning",
                  });
                }
              });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
      this.$refs.uploads.clearFiles();
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
#decLeftNav {
  width: 2.5rem;
  margin-top: 1rem;

  .navTop {
    width: 100%;
    font-size: 0.18rem;
    display: flex;
    flex-direction: column;

    >.img {
      width: 1.7rem;
      height: 2.2rem;
      padding: 0.45rem 0.25rem;
      background: #efefef;

      >img {
        width: 100%;
        height: 100%;
      }
    }

    >img {
      width: 1.7rem;
      height: 2.2rem;
    }

    >div {
      span {
        margin-top: 0.1rem;
        display: block;

        &.date {
          color: #939393;
        }
      }
    }

    .up {
      width: 1.7rem;
      height: 0.35rem;
      line-height: 0.35rem;
      background: #2d65d2;
      cursor: pointer;
      margin: 0;
      position: relative;
      // padding-left: 0.4rem;
      text-align: center;
      color: #fff;

      img {
        width: 0.24rem;
        height: 0.21rem;
        position: absolute;
        left: 0.15rem;
        top: 0.07rem;
      }
    }

    .name {
      display: flex;
      font-size: 0.2rem;
      font-weight: bold;
      margin: 0.2rem 0;

      img {
        width: 0.25rem;
        height: 0.28rem;
        margin-right: 0.1rem;
      }
    }
  }

  .nav {
    width: 100%;
    font-size: 0.18rem;
    margin-top: 0.2rem;

    >.btn {
      height: 0.4rem;
      width: 1.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #57a6f7;
      color: #fff;
      cursor: pointer;
    }

    >ul {
      width: 100%;

      >li {
        width: 100%;

        .Major {
          cursor: pointer;
          width: 100%;
          height: 0.5rem;
          border-radius: 0.05rem;
          display: flex;
          padding: 0.05rem 0.15rem;
          justify-content: space-between;
          align-items: center;
          margin: 0.15rem 0;
          border: 0.01rem solid #afafaf;

          &:last-child {
            margin-bottom: 0;
          }

          >div {
            display: flex;
            align-items: center;

            img {
              width: 0.2rem;
              margin-right: 0.1rem;
            }

            svg {
              width: 0.2rem;
              height: 0.2rem;
              margin-right: 0.1rem;
            }
          }

          >img {
            width: 0.15rem;
          }

          &.active {
            background: #57a6f7;
            border: 0;
            color: #ffffff;
          }
        }

        div {
          li {
            padding: 0.1rem 0.15rem;
            display: block;
            cursor: pointer;

            &.active {
              color: #57a6f7;
            }
          }
        }
      }
    }
  }
}
</style>